import notFound from '../../views/Error/notFound'
import accessDeny from '../../views/Error/accessDeny'
import vehicleReservationDeny from '../../views/Error/vehicleReservationError'
export default [
  /* -------------- 404 -------------- */
  {
    path: '*',
    redirect: '/not-found'
  },
  {
    path: '/not-found',
    name: 'NotFound',
    component: notFound,
    meta: {
      singlePage: true, // 不在Main中显示
    }
  },
  /* -------------- 401 -------------- */
  {
    path: '/access-deny',
    name: 'AccessDeny',
    component: accessDeny,
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
  {
    path: '/vehicle-access-deny',
    name: 'VehicleReservationDeny',
    component: vehicleReservationDeny,
    meta: {
      singlePage: true, // 不在Main中显示
      noLoginRequired: true, // 无需登录即可进入
    }
  },
]
